import React from "react";
import NewsPost from "@components/News/NewsPost";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const NewsItemPage = () => {

    return (
        <VersionedLayout>
            <NewsPost />
        </VersionedLayout>
    );
};

export default NewsItemPage;
